import { getMarketPlaceRoute, useGet2ndLevelPageUrl } from 'app-level/navigation';
import { ExecutedOverview } from 'features/deals/Executed';
import ListingOverview from 'features/listings/ListingOverview';
import { Navigate, Route, Routes } from 'react-router-dom';

import ActiveTrades from './ActiveTrades/ActiveTrades';
import { DealRoom } from './DealRoom';
import MarketHome from './MarketHome';

const Marketplace = () => {
  const getUrl = useGet2ndLevelPageUrl();

  return (
    <Routes>
      <Route index element={<Navigate to={getUrl('marketplace', 'market-home')} replace />} />
      <Route path="active_trades" element={<Navigate to="active_trades/all" replace />} />
      <Route path="active_trades/:tab" element={<ActiveTrades />} />
      <Route path={getMarketPlaceRoute('market-home')} element={<MarketHome />} />
      <Route path={getMarketPlaceRoute('executed_trades')} element={<ExecutedOverview />} />
      <Route path="listing/:listing_id" element={<ListingOverview />} />
      <Route path="deal/:deal_id" element={<DealRoom />} />
      <Route path="*" element={<Navigate to={getUrl('marketplace', 'market-home')} replace />} />
    </Routes>
  );
};

export default Marketplace;
